import React from 'react';
import styles from './CartComponent.scss';

export default function CartComponent({
  items, empty = true, active, colored, to = '', onClick
}) {
  let icon;
  switch (true) {
    case colored:
      icon = 'cartIconColored';
      break;

    case empty:
      icon = 'cartIconEmpty';
      break;

    default:
      icon = 'cartIcon';
  }
  return (
    <span
      onClick={onClick}
      className={styles.cart}>
      <p className={icon} />
      {items? (
        <div className={styles.cartIndicator}>
          {items > 99
            ? '99+'
            : items
          }
        </div>
      ) : null}
    </span>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Cart/CartComponent.jsx
 **/